import React, { useEffect } from 'react';
import { useHandleInputChange } from '../../hook/useHandleInputChange';
import { useTranslation } from 'react-i18next';
import InputDateWithYear from '../../components/common/Input/inputDateWithYear';
import InputNumber from '../../components/common/Input/inputNumber';
import InputSelect from '../../components/common/Input/inputSelect';
import InputText from '../../components/common/Input/inputText';
import FilterBodyComponent from "../../components/rGlobalComponents/FilterBodyComponent";
import { useArea } from '../../features/area/useArea';
import { useSerivePointTypes } from '../../features/servicePointType/useServicePointType';
import { initialState } from './initialStates/filter';
import '../../style/filter.css';
import { useQuery } from '../../hook/useQuery';
import useFormStateByQuery from '../../hook/useFormStateByQuery';
import _ from 'lodash';
const Filter = ({ handleFilterData }) => {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const { formStateByQuery } = useFormStateByQuery(initialState);
    const { formState, handleInputChange, setFormState } = useHandleInputChange(formStateByQuery);
    const { allservicepointTypes, fetchAllData } = useSerivePointTypes();
    const { allAreas, fetchAllData: getAllAreas } = useArea();
    const { getQueryString, resetFilterUrl } = useQuery(formState);

    const handleFilter = async (e) => {
        e.preventDefault();
        const queryString = getQueryString();
        await handleFilterData(queryString);
    };

    const handleRestFilter = (e) => {
        e.preventDefault();
        setFormState(initialState)
        resetFilterUrl();
        handleFilterData(null);
    };
    useEffect(() => {
        const debouncedFetch = _.debounce(() => {
            fetchAllData();
            getAllAreas();
        }, 300);
        debouncedFetch();
        return debouncedFetch.cancel;
    }, []);

    return (
        <FilterBodyComponent handleFilter={handleFilter} handleRestFilter={handleRestFilter} formState={formState}>

            <InputDateWithYear
                className="col-md-2"
                name="start_date"
                label={t("properties.start_time")}
                value={formState?.start_date}
                onChange={handleInputChange}
            />

            <InputDateWithYear
                className="col-md-2"
                name="end_date"
                label={t("properties.end_time")}
                value={formState?.end_date}
                onChange={handleInputChange}
            />

            <InputSelect
                className="col-md-2"
                name="servicepoint_type_id"
                field="name"
                label={t("properties.servicePointType")}
                options={allservicepointTypes}
                value={formState.servicepoint_type_id}
                onChange={handleInputChange}
                lang={lang}
            />
            <InputSelect
                className="col-md-2"
                name="area_id"
                label={t("properties.area_id")}
                options={allAreas}
                field="name"
                value={formState.area_id}
                onChange={handleInputChange}
                lang={lang}
            />
            <InputText
                className="col-md-2"
                name="name"
                label={t("properties.name")}
                value={formState?.name}
                onChange={handleInputChange}
            />
            <InputText
                className="col-md-2"
                name="relevant_person"
                label={t("properties.relevant_person")}
                value={formState?.relevant_person}
                onChange={handleInputChange}
            />
            <InputText
                className="col-md-2"
                name="address"
                label={t("properties.address")}
                value={formState?.address}
                onChange={handleInputChange}
            />
            <InputNumber
                className="col-md-2"
                name="servicepoint_number"
                label={t("properties.servicepoint_number")}
                value={formState?.servicepoint_number}
                onChange={handleInputChange}
            />
            <InputText
                className="col-md-2"
                name="phone"
                label={t("properties.phone")}
                value={formState?.phone}
                onChange={handleInputChange}
            />
        </FilterBodyComponent>
    );
};

export default React.memo(Filter);